import { BrowserModule } from "@angular/platform-browser";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { MatCheckboxModule } from "@angular/material/checkbox";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { MatDialogModule } from "@angular/material/dialog";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatRadioModule } from "@angular/material/radio";
import { MatCardModule } from "@angular/material/card";

import { LoginComponent } from "./login/login.component";
import { PatientsComponent } from "./patients/patients.component";
import { PaginationControlsComponent } from "./pagination-controls/pagination-controls.component";
import { BottombarComponent } from "./bottombar/bottombar.component";
import { PatdetailsComponent } from "./patdetails/patdetails.component";

import { DocpanelComponent } from "./docpanel/docpanel.component";
import { TotpboxComponent } from "./totpbox/totpbox.component";

import { NgChartsModule } from "ng2-charts";

import { LightboxModule } from "ngx-lightbox";

import { TranslateModule, TranslateLoader, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AutotextComponent } from "./autotext/autotext.component";
import { AutotextRowComponent } from "./autotext-row/autotext-row.component";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
import { MatChipsModule } from "@angular/material/chips";
import { MatListModule } from "@angular/material/list";
import { GenradioComponent } from "./genradio/genradio.component";

import { InterceptorService } from "./interceptor.service";
import { CommerrorComponent } from "./commerror/commerror.component";

import { LoginboxComponent } from "./loginbox/loginbox.component";

import { AngularEditorModule } from "@kolkov/angular-editor";

import { GeninputComponent } from "./geninput/geninput.component";

import { MapPipe } from "./pipes/map.pipe";
import { FilterPipe } from "./pipes/filter.pipe";
import { SetPipe } from "./pipes/set.pipe";
import { ToArrayPipe } from "./pipes/to-array.pipe";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { MatSelectModule } from "@angular/material/select";

import { UniqueAutoIndexPipe } from "./pipes/unique-auto-index.pipe";
import { SortCreationTimePipe } from "./pipes/sort-creation-time.pipe";

import { WeeksDaysPipe } from "./pipes/weeks-days.pipe";
import { UniqueExamsPipe } from "./pipes/unique-exams.pipe";
import { DatePipe } from "@angular/common";
import { FullCalendarModule } from "@fullcalendar/angular";
import { AppointmentsGeneralComponent } from "./appointments-general/appointments-general.component";
import { AppointmentComponent } from "./appointment/appointment.component";
import { MatStepperModule } from "@angular/material/stepper";
import { BlockComponent } from "./block/block.component";
import { BarComponent } from "./bar/bar.component";
import { LegendComponent } from "./legend/legend.component";
import { PatientInfoComponent } from "./patient-info/patient-info.component";
import { SortByDateTimePipe } from "./pipes/sort-by-date-time.pipe";
import { UserSettingsComponent } from "./user-settings/user-settings.component";
import { ExamsNamesComponent } from "./exams-names/exams-names.component";
import { QuestionnaireTemplatesComponent } from "./questionnaire-templates/questionnaire-templates.component";
import { ActivityHoursComponent } from "./activity-hours/activity-hours.component";
import { InvoiceComponent } from "./invoice/invoice.component";
import { SearchComponent } from "./search/search.component";
import { NavComponent } from "./nav/nav.component";
import { BillingComponent } from "./billing/billing.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PrintAppointmentsComponent } from "./print-appointments/print-appointments.component";
import { SmsSettingsComponent } from "./sms-settings/sms-settings.component";
import { SafeUrlPipe } from "./safe-url.pipe";
import { PriceListComponent } from "./price-list/price-list.component";
import { HmoPriceListComponent } from "./hmo-price-list/hmo-price-list.component";
import { AppointmentListComponent } from "./appointment-list/appointment-list.component";
import { LeadsComponent } from "./leads/leads.component";
import { LeadFormDialogComponent } from "./lead-form-dialog/lead-form-dialog.component";
import { SortByCreationTimePipe } from "./pipes/sort-by-creation-time.pipe";
import { RoomsActivityHoursComponent } from "./rooms-activity-hours/rooms-activity-hours.component";
import { RoomsComponent } from "./rooms/rooms.component";
import { SearchAppointmentsComponent } from "./search-appointments/search-appointments.component";
import { PatDocumentsComponent } from "./pat-documents/pat-documents.component";
import { FileSizePipe } from "./pipes/file-size.pipe";
import { BillingReportsComponent } from "./billing-reports/billing-reports.component";
import { PrintBillingReportComponent } from "./print-billing-report/print-billing-report.component";
import { PrintQuestionnaireComponent } from "./print-questionnaire/print-questionnaire.component";
import { HmoQuotaComponent } from "./hmo-quota/hmo-quota.component";
import { SortByDatePipe } from "./sort-by-date.pipe";
import { AllDayEventComponent } from "./all-day-event/all-day-event.component";
import { FilterArrOfObjByValPipe } from "./pipes/filter-arr-of-obj-by-val.pipe";
import { MultiSelectManagerComponent } from "./multi-select-manager/multi-select-manager.component";
import { MatDividerModule } from "@angular/material/divider";
import { AppointmentChangesDialogComponent } from "./appointment-changes-dialog/appointment-changes-dialog.component";
import { SendWhatsappDialogComponent } from "./send-whatsapp-dialog/send-whatsapp-dialog.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MessagingAppDialogComponent } from "./messaging-app-dialog/messaging-app-dialog.component";
import { MatBadgeModule } from "@angular/material/badge";
import { ApptStatsComponent } from "./appt-stats/appt-stats.component";
import { PerformerPriceListComponent } from "./performer-price-list/performer-price-list.component";
import { FinancialReportComponent } from "./financial-report/financial-report.component";
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from "@angular/material/tabs";
import { VersionPopupComponent } from "./version-popup/version-popup.component";
import { AnnouncementHostComponent } from './announcement-host/announcement-host.component';
import { BlocksManagementComponent } from './blocks-management/blocks-management.component';
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { AttendanceTrackerComponent } from "./attendance-tracker/attendance-tracker.component";
import { AttendanceReportComponent } from "./attendance-report/attendance-report.component";
import { SmsRemindersTrackingComponent } from "./sms-reminders-tracking/sms-reminders-tracking.component";
import { AccessDeniedComponent } from "./access-denied/access-denied.component";
import { SmsDetailsDialogComponent } from "./sms-reminders-tracking/sms-details-dialog.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TrainingHubComponent } from "./training-hub/training-hub.component";
import { TransferAppointmentsComponent } from "./transfer-appointments/transfer-appointments.component";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", `.json?v=${new Date().getTime()}`);
}

export function preloadAllTranslations(ts: TranslateService) {
  return () => {
    // Pre-load the translation JSON files:
    const langs = ["en-US", "ar-JO", "es-ES", "he-IL", "it-IT", "pl-PL"];
    return Promise.all(langs.map((lang) => ts.getTranslation(lang).toPromise()));
  };
}

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        PatientsComponent,
        PaginationControlsComponent,
        BottombarComponent,
        PatdetailsComponent,
        DocpanelComponent,
        AutotextComponent,
        AutotextRowComponent,
        GenradioComponent,
        CommerrorComponent,
        LoginboxComponent,
        GeninputComponent,
        MapPipe,
        FilterPipe,
        SetPipe,
        ToArrayPipe,
        UniqueAutoIndexPipe,
        SortCreationTimePipe,
        TotpboxComponent,
        WeeksDaysPipe,
        UniqueExamsPipe,
        AppointmentsGeneralComponent,
        AppointmentComponent,
        BlockComponent,
        BarComponent,
        LegendComponent,
        PatientInfoComponent,
        SortByDateTimePipe,
        UserSettingsComponent,
        ExamsNamesComponent,
        QuestionnaireTemplatesComponent,
        ActivityHoursComponent,
        InvoiceComponent,
        SearchComponent,
        NavComponent,
        BillingComponent,
        PrintAppointmentsComponent,
        SmsSettingsComponent,
        SafeUrlPipe,
        PriceListComponent,
        HmoPriceListComponent,
        AppointmentListComponent,
        LeadsComponent,
        LeadFormDialogComponent,
        SortByCreationTimePipe,
        RoomsActivityHoursComponent,
        RoomsComponent,
        SearchAppointmentsComponent,
        PatDocumentsComponent,
        FileSizePipe,
        BillingReportsComponent,
        PrintBillingReportComponent,
        PrintQuestionnaireComponent,
        HmoQuotaComponent,
        SortByDatePipe,
        AllDayEventComponent,
        FilterArrOfObjByValPipe,
        MultiSelectManagerComponent,
        AppointmentChangesDialogComponent,
        SendWhatsappDialogComponent,
        MessagingAppDialogComponent,
        ApptStatsComponent,
        PerformerPriceListComponent,
        FinancialReportComponent,
        VersionPopupComponent,
        ForgotPasswordComponent,
        BlocksManagementComponent,
        AttendanceTrackerComponent,
        AttendanceReportComponent,
        SmsRemindersTrackingComponent,
        AccessDeniedComponent,
        SmsDetailsDialogComponent,
        PrivacyPolicyComponent,
        TrainingHubComponent,
        TransferAppointmentsComponent,
    ],
    exports: [FilterArrOfObjByValPipe],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgChartsModule,
        LightboxModule,
        MatDatepickerModule,
        MatTableModule,
        MatIconModule,
        MatBadgeModule,
        MatButtonModule,
        MatMomentDateModule,
        MatTooltipModule,
        MatMenuModule,
        MatDialogModule,
        MatCheckboxModule,
        AngularEditorModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatInputModule,
        MatExpansionModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatRadioModule,
        FullCalendarModule,
        MatStepperModule,
        DragDropModule,
        MatCardModule,
        MatChipsModule,
        MatDividerModule,
        MatListModule,
        MatSnackBarModule,
        MatTabsModule,
        MatPaginatorModule,
        MatSortModule,
        MatBadgeModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        AnnouncementHostComponent], providers: [
        MatDatepickerModule,
        MatTooltipModule,
        UniqueExamsPipe,
        DatePipe,
        FilterArrOfObjByValPipe,
        { provide: MAT_DATE_LOCALE, useValue: "he-IL" },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        },
        provideAppInitializer(() => {
        const initializerFn = (preloadAllTranslations)(inject(TranslateService));
        return initializerFn();
      }),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
